import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
window.$ = require('jquery');
window.Jquery = require('jquery');

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
axios.defaults.baseURL = "https://transmall.shop/api/v1"
 //axios.defaults.baseURL = "http://127.0.0.1:8000/api/v1"


// v-lazy
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
})
// import vue-js -modal
import VModal from 'vue-js-modal'
Vue.use(VModal)

//vue progressbar
import VueProgressBar from 'vue-progressbar'

const options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'left',
  inverse: false
}

Vue.use(VueProgressBar, options)

//vue toast notification

import VueToast from 'vue-toast-notification';
// Import any of available themes
import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);
// VueRadioToggleButtons
import VueRadioToggleButtons from 'vue-radio-toggle-buttons';
import 'vue-radio-toggle-buttons/dist/vue-radio-toggle-buttons.css';
Vue.use(VueRadioToggleButtons, {
  color: '#333',
  textColor: '#333',
  selectedTextColor: '#eee'
});

// jw-vue-pagination
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination)

//pagiantion
Vue.component('pagination', require('laravel-vue-pagination'));

//Vue-Google-Places
import VueGooglePlaces from "vue-google-places";
Vue.use(VueGooglePlaces);
// key: "AIzaSyD_q2KJ5vODTs1xOXxn6j8gjX5ZMr-2YzY"

//sweetalert
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

//vue file agent
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
Vue.use(VueFileAgent);
//vue-nav-tabs
import mergeProps from '@vue/babel-helper-vue-jsx-merge-props';
import Tabs from 'vue-nav-tabs/dist/vue-tabs.js';
import 'vue-nav-tabs/themes/vue-tabs.css';
Vue.use(Tabs);

//vue-good-table
import VueGoodTablePlugin from 'vue-good-table/src';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);
//sweet-modal
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
Vue.use(SweetModal,SweetModalTab);
//steps
import VueGoodWizard from 'vue-good-wizard';
Vue.use(VueGoodWizard);
// websanova
Vue.router = router;
Vue.use(require("@websanova/vue-auth"), {
  auth: require("@websanova/vue-auth/drivers/auth/bearer.js"),
  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
  rolesVar: "role",
  tokenStore: ["localStorage", "cookie"]
});
//Google maps
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD_q2KJ5vODTs1xOXxn6j8gjX5ZMr-2YzY',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    region: 'KE',
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

//Vue-carousel
import VueCarousel from "vue-carousel";
Vue.use(VueCarousel);


//numeric comma separator
Vue.filter('formatNumber', function (value) {
  const rounded =  Math.round(value * 100) / 100
  return rounded.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.config.productionTip = false

Vue.use(ArgonDashboard)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
